var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',{staticClass:"text-center"},[_vm._l((_vm.$options.icons),function(icon,iconName){return [_c('CCol',{staticClass:"mb-5",attrs:{"col":"3","sm":"2"}},[_c('CIcon',{attrs:{"height":42,"content":icon}}),_c('div',[_vm._v(_vm._s(iconName))]),_c('div',[_vm._v(_vm._s(_vm.camelToKebab(iconName)))])],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }